var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('PersonProfile',{attrs:{"outlined":"","person":_vm.person}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }